import { baseApi } from "./baseApi";

const DO_SPACE_URL = "/doSpace";

export const doSpaceApi = baseApi.injectEndpoints({
  tagTypes: ["doSpace"],
  endpoints: (builder) => ({
    doSpaceFileUpload: builder.mutation({
      query: ({ file, entityId, filePath }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("entityId", entityId);
        formData.append("filePath", filePath);

        return {
          url: `${DO_SPACE_URL}`,
          method: "POST",
          body: formData,
          formData: true,
        };
      },
    }),

    doSpaceFileDelete: builder.mutation({
      query: (payload) => ({
        url: `${DO_SPACE_URL}`,
        method: "DELETE",
        body: payload,
      }),
    }),
  }),
});

export const { useDoSpaceFileUploadMutation, useDoSpaceFileDeleteMutation } =
  doSpaceApi;
